// extracted by mini-css-extract-plugin
module.exports = {"section":"J_section__iwv1t","scroll":"J_scroll__5_vsc"};